<template>
    <div class="shop-cart">
        <template
         v-if="!isSuccess"
        >
            <breadcrumb />
        </template>
        <router-view
            :key="$route.name"
            :data="loadData()"
            @valid="checkForm"
        />
        <actions
            :data="loadData()"
            :redirect="redirect"
            :hasPayment="hasPayment"
        />
    </div>
</template>

<script>
    import { isNil, is, mergeAll, hasIn } from 'ramda';
    import LocaleStorage from 'local-storage';

    import Breadcrumb from './components/Breadcrumb';
    import Actions from './components/Actions';

    const storage = hasIn('storage_prefix', window.groovie) ? `${window.groovie.storage_prefix}_` : '';

    export default {
        name: 'shopping-cart',
        data() {
            return {
                redirect: false
            };
        },
        computed: {
            hasNext() {
                return this.redirect;
            },
            isSuccess() {
                return this.$route.name === 'success';
            },
            hasPayment() {
                const data = this.loadData();
                const result = hasIn('payment', data) && hasIn('type', data.payment) && !isNil(data.payment.type)
                    && (this.$route.name === 'check' || this.$route.name === 'fail');

                if (!result && (this.$route.name === 'check' || this.$route.name === 'fail')) {
                    console.error('Has Payment', hasIn('payment', data));
                    console.error('Has Payment Type', hasIn('type', data.payment));
                    console.error('Payment type', isNil(data.payment.type));
                }

                return result;
            }
        },
        methods: {
            checkForm(data) {
                const oldData = this.loadData();
                if (!isNil(data) && is(Object, data)) {
                    LocaleStorage.set(`${storage}client_data`, mergeAll([oldData, data]));
                }

                this.$set(this, 'redirect', !isNil(data) && data !== false);
            },
            loadData() {
                let data = LocaleStorage.get(`${storage}client_data`);
                if (isNil(data)) {
                    data = {
                        name: '',
                        lastName: '',
                        phone: '',
                        email: '',
                        address: '',
                        city: '',
                        country: '',
                        postal: '',
                        observations: ''
                    };
                }

                return data;
            }
        },
        components: {
            Breadcrumb,
            Actions
        }
    };
</script>



// WEBPACK FOOTER //
// src/ShoppingCart.vue